import React from "react";

const DownloadComponent = () => {

  return(
    <React.Fragment>
      <h1>Pobieranie</h1>
    </React.Fragment>
  )

}
export default DownloadComponent;